import React from 'react';
import { Chip } from '@mui/material';
import { ReferralStage } from '~/types/transition';

interface ReferralStageBadgeProps {
  stage: ReferralStage;
  size?: 'small' | 'medium';
}

const STAGE_CONFIG: Record<ReferralStage, { label: string; color: 'default' | 'info' | 'warning' | 'success' }> = {
  [ReferralStage.INTAKE]: { label: 'Intake', color: 'default' },
  [ReferralStage.PROCESSING]: { label: 'Processing', color: 'info' },
  [ReferralStage.DECISION]: { label: 'Decision', color: 'warning' },
  [ReferralStage.EXECUTION]: { label: 'Execution', color: 'success' },
};

const ReferralStageBadge: React.FC<ReferralStageBadgeProps> = ({ stage, size = 'small' }) => {
  const config = STAGE_CONFIG[stage];
  return (
    <Chip
      label={config.label}
      size={size}
      color={config.color}
      sx={{ fontWeight: 600, fontSize: '0.7rem' }}
    />
  );
};

export default ReferralStageBadge;
